/* CREATE FILE NAMED config.dev.js */
var fixtures = require('../js/clients/mock/fixtures.js');

export default {
  debug: true,
  defaultUrl: 'school/test_schedules/schedules/2016_2017',
  fixtures: fixtures,
  use_fixtures: false,
  feature_flags: {
    cohort_selection: true,
    core_vs_noncore_layers: true
  },
  reduxDevTools: window.devToolsExtension
};



/** WEBPACK FOOTER **
 ** ./src/config/config.dev.js
 **/